import { useBarcodeValidation } from '../hooks/useBarcodeValidation';
import {
  ValidationHeader,
  ValidationPhotoManager,
  BarcodeInputSection,
  ParsedDataDisplay,
  ExpectedDataForm,
  ValidationResultsPanel,
  SavedCasesManager,
  CaseNavigator,
} from '../components/barcode-validation';

export function BarcodeValidationPage() {
  const validation = useBarcodeValidation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-cyan-50 p-4 sm:p-6">
      <div className="max-w-4xl mx-auto space-y-5">
        <ValidationHeader />

        <CaseNavigator
          cases={validation.savedCases}
          currentIndex={validation.currentCaseIndex}
          onNavigate={validation.navigateCase}
          onLoadSamples={validation.loadSamples}
        />

        <ValidationPhotoManager
          photos={validation.photos}
          onAddPhoto={validation.addPhoto}
          onRemovePhoto={validation.removePhoto}
        />

        <BarcodeInputSection
          rawBarcode={validation.rawBarcode}
          scanType={validation.parsedData?.scanType ?? null}
          onRawChange={validation.setRawBarcode}
          onParse={() => validation.parseBarcode(validation.rawBarcode)}
        />

        <ParsedDataDisplay data={validation.parsedData} />

        <ExpectedDataForm
          data={validation.expectedData}
          onFieldChange={validation.updateExpectedField}
          onClear={validation.clearExpected}
        />

        <ValidationResultsPanel
          results={validation.validationResults}
          onValidate={validation.runValidation}
          canValidate={!!validation.parsedData}
        />

        <SavedCasesManager
          cases={validation.savedCases}
          onSave={validation.saveCase}
          onLoad={validation.loadCase}
          onDelete={validation.deleteCase}
        />
      </div>
    </div>
  );
}
